import { LikeFilter } from 'slipstream-components';

export default class RegexpLikeFilter extends LikeFilter {
  public static parseFilter(segs: string[]): LikeFilter {
    const not = segs[3] === 'true';
    const name = segs[2] || segs[1];
    const field = segs[0];
    const value = segs[1];
    const filter = new LikeFilter(field, value, not, name);
    return filter;
  }
  constructor(field: string, value: string, not = false, name = field) {
    super(field, value, not, name);
  }
}
